import React, { useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import { useTranslation } from "react-i18next";
import { mergColumns } from "../ShareFunctionsPrint";

function BodyCashair(props) {
    const { data, onUnmountComplete,locInv } = props;

    const { t } = useTranslation(["forms", "translation"]);
    const cellS = {

        padding: "0px 0.1px",
        textAlign: "-webkit-center",
        margin: "0px",
        whiteSpace: "normal",
        border: "solid 0.1px",
        fontSize: "0.65rem",
        width: "250px",
        textAlign: "right",
        paddingRight: "0.6rem",
        fontFamily: "Amiri-Regular",
        fontWeight: "bold",
        paddingTop: "0.1rem",
        paddingBottom: "0.1rem"
    };

    const styleCe = {
        fontFamily: "Amiri-Regular",
        border: "solid 1px ",
        borderColor: "black",
        textAlign: "center",
        fontSize: "0.65rem",
        color: "black",
        fontWeight: "bold",
        padding: "0.1px"
    };


    const styleE = {
        border: "solid 1px ",
        borderColor: "black",
        textAlign: "center",
        fontSize: "0.8rem",
        color: "black",
        fontWeight: "bold",
    };

    const cellSName = {

        padding: "0px 0px",
        textAlign: "-webkit-center",
        margin: "0px",
        whiteSpace: "normal",
        border: "solid 0.1px",
        fontSize: "0.8rem",
        width: "600px",
        fontFamily: "Amiri-Regular",
        fontWeight: "bold",
    };


    const premiApp = JSON.parse(localStorage.getItem("premiApp")) || {};
    const mergColumn = (symbol, nameEN) => {
        if (nameEN != null && nameEN != "") {
            return `${nameEN} \n ${symbol}`
        } else {
            return `${symbol}`
        }
    };

    useEffect(() => {
        setTimeout(async () => {
            onUnmountComplete();
        }, 0);
    }, []);

    return (
        <Grid item container style={{ fontFamily: "Amiri-Regular" }}>
            <Grid item container xs={12} style={{ direction: "rtl", }}>
                <Grid container xs={12}>
                    <Grid item xs={locInv?.post == 2?7:premiApp?.cashirTemplate == 5 ? 5 : 4} style={styleE}>
                        {premiApp?.cashirTemplate == 5 ? "البيان" : "اسم الصنف"}
                    </Grid>
                    {premiApp?.cashirTemplate !== 5 && (
                        <Grid item xs={locInv?.post == 2?3: 2} style={styleE}>
                            {"الوحده"}
                        </Grid>
                    )}

                    <Grid item xs={2} style={styleE}>
                        {"الكمية"}
                    </Grid>
                    {locInv?.post != 2 &&
                        <>
                            <Grid item xs={2} style={styleE}>
                                {"السعر"}
                            </Grid>
                            <Grid item xs={premiApp?.cashirTemplate == 5 ? 3 : 2} style={styleE}>
                                {"الاجمالي"}
                            </Grid></>}
                    {data?.map((d) => {
                        return (
                            <Grid
                                container
                                item
                                xs={12}
                                style={{ width: "100%" }}
                            >
                                <Grid item xs={locInv?.post == 2?7: premiApp?.cashirTemplate == 5 ? 5 : 4} style={cellSName}>
                                    {premiApp?.cashirTemplate == 5 || premiApp?.cashirTemplate == 7 ? d.symbol
                                        : mergColumns(d.symbol, d?.nameEN) + (d?.notes_details != "" ? "\n" + d?.notes_details : "")}
                                </Grid>
                                {premiApp?.cashirTemplate !== 5 && (
                                    <Grid item xs={locInv?.post == 2?3:2} style={styleCe}>
                                        {d.unit_name}
                                    </Grid>
                                )}
                                <Grid item xs={2} style={styleCe}>
                                    {d.val1}
                                </Grid>
                                {locInv?.post != 2 &&
                                    <> <Grid item xs={2} style={styleCe}>
                                        {d.priceC}
                                    </Grid>
                                        <Grid item xs={premiApp?.cashirTemplate == 5 ? 3 : 2} style={styleCe}>
                                            {d?.netTotal}
                                        </Grid></>}
                            </Grid>
                        );
                    })}
                </Grid>
            </Grid>


        </Grid>
    );
}

export default BodyCashair;
